import React from 'react';
import { X } from 'lucide-react';
import EmailConfigForm from './EmailConfigForm';
import { EmailConfig } from '../../services/emailConfigService';

interface EmailConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialData?: EmailConfig;
  onSuccess?: (data: EmailConfig) => void;
  tenantId?: string;
  insideForm?: boolean; // Set to true when used inside another form
}

const EmailConfigModal: React.FC<EmailConfigModalProps> = ({
  isOpen,
  onClose,
  initialData,
  onSuccess,
  tenantId,
  insideForm = false
}) => {
  if (!isOpen) return null;

  const handleSuccess = (data: EmailConfig) => {
    if (onSuccess) {
      onSuccess(data);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
        </div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-background-card rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          {/* Header */}
          <div className="bg-slate-800/70 px-4 py-3 flex justify-between items-center">
            <h3 className="text-lg leading-6 font-medium text-white">
              {initialData ? 'Edit Email Configuration' : 'Add Email Configuration'}
            </h3>
            <button
              type="button"
              className="bg-transparent rounded-md text-gray-400 hover:text-white focus:outline-none"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <EmailConfigForm
              initialData={initialData}
              onSuccess={handleSuccess}
              onCancel={onClose}
              tenantId={tenantId}
              noForm={insideForm}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfigModal;
